import { howItWorksFunctions } from './howItWorks'

/** Illustrative workflow: a request becomes a reviewed next step, then progress review. */
export const informationToAction = [
  { step: 'A request arrives', body: 'A resident asks for help finding a training place they can reach.' },
  { step: 'Information is checked', body: 'The team sees what is already known and asks only for what is missing.' },
  { step: 'The right team takes it', body: 'Responsibility is assigned, so nothing waits in a shared inbox.' },
  { step: 'Support is coordinated', body: 'A referral shares only what the resident agreed to share.' },
  { step: 'The outcome is recorded', body: 'The decision and its reason are visible to the resident and the team.' },
  { step: 'Progress is reviewed', body: 'Later, the team checks what helped and improves the service.' },
]

/** Three connected functions for the homepage "How it works" section. */
export const homeFunctions = howItWorksFunctions

export const homeResearchPoints = [
  'Knowledge systems that keep every finding connected to its source',
  'The Human Capability Framework, CJI and NCJI’s five pillars',
  'Studies, pilots and publication plans, labeled by status',
]
